import { render, staticRenderFns } from "./CustomerCampaignReceipt.vue?vue&type=template&id=d1d85dde&scoped=true"
import script from "./CustomerCampaignReceipt.vue?vue&type=script&lang=js"
export * from "./CustomerCampaignReceipt.vue?vue&type=script&lang=js"
import style0 from "./CustomerCampaignReceipt.vue?vue&type=style&index=0&id=d1d85dde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d85dde",
  null
  
)

export default component.exports